import script from "./MedicalTreatment.vue?vue&type=script&lang=ts&setup=true"
export * from "./MedicalTreatment.vue?vue&type=script&lang=ts&setup=true"

import "./MedicalTreatment.vue?vue&type=style&index=0&id=4eacbc86&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eacbc86"]])

export default __exports__